export const cobrosKeys = {
  all: ['cobros'] as const,
  lists: () => [...cobrosKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...cobrosKeys.lists(), filters] as const,
  // Stats cuelgan de lists() para que invalidar el listado también refresque los KPIs.
  stats: (filters: Record<string, unknown>) => [...cobrosKeys.lists(), 'stats', filters] as const,
  details: () => [...cobrosKeys.all, 'detail'] as const,
  detail: (id: number) => [...cobrosKeys.details(), id] as const,
};

export const cobroGeneracionKeys = {
  all: [...cobrosKeys.all, 'generacion'] as const,
  lists: () => [...cobroGeneracionKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...cobroGeneracionKeys.lists(), filters] as const,
  details: () => [...cobroGeneracionKeys.all, 'detail'] as const,
  detail: (id: number) => [...cobroGeneracionKeys.details(), id] as const,
  schedule: () => [...cobroGeneracionKeys.all, 'schedule'] as const,
};
